// extracted by mini-css-extract-plugin
module.exports = {"containerPosition":"styles_containerPosition__f8bNF","sliderBackgroundColor":"styles_sliderBackgroundColor__uNzPb","title":"styles_title__UAthq"};